var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResOtherIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "{color}",
  stroke: "{secondaryColor}",
  strokeWidth: 2,
  d: "M1.876 7.577 13 1.155l11.124 6.422v12.846L13 26.845 1.876 20.423z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 14,
  r: 7,
  stroke: "#fff",
  strokeWidth: 2
})));
export default SvgResOtherIcon;